import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Box, Divider, Typography } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import { MENU_ITEMS, SECOND_MENU, ADMIN_MENU_ITEMS, ALLOWED_COMPANIES_MENU_ITEMS, BAVENCIO_MENU_ITEMS, DRAWER_WIDTH, CompanyUserBasedTabs, OminiChannelMenu, CREATIVE_MENU, OminiChannelAdminMenu } from './constants';
import { Logo, LogoWithoutBrandname } from '../../assets';
import { ForwardButton, BackButton } from '../../assets/sidebar-icons';
import { setSideBarMenuItemId } from '../../redux/reducers/headerReducer';
import { BAVENCIO_COMPANY_ID, BAVENCIO_COMPANY_USERS_TO_SHOW_EXTRA_TABS, MENU_ITEM_IDS, showCreative, TEPMETKO_COMPANY_ID } from '../../constants';
import routeNames from '../../routes/routeNames';

export default function SideBar(props) {
    const navigate = useNavigate();
    const [menuItem, setMenuItem] = useState(MENU_ITEMS);
    const [secondMenu,setSecondMenu] = useState(SECOND_MENU);
    const {
        closeDrawer, openDrawer, drawerOpen
    } = props;
    const dispatch = useDispatch();
    const { selectedMenuItemId } = useSelector((state) => state.header);
    const {
        userDetails: {
            is_admin, is_staff = 0, email, company: userCompany
        }
    } = useSelector((state) => state.user);
    const { company: selectedCompany,isOmaniChannel } = useSelector((state) => state.company);

    const openedMixin = (theme) => ({
        width: DRAWER_WIDTH,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        overflowX: 'hidden',
        backgroundColor: '#F9FAFB'
    });

    const closedMixin = (theme) => ({
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        backgroundColor: '#F9FAFB',
        width: `calc(${theme.spacing(7)} + 1px)`,
        [theme.breakpoints.up('sm')]: { width: `calc(${theme.spacing(8)} + 1px)` }
    });

    const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
        width: DRAWER_WIDTH,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme)
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme)
        })
    }));

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar
    }));

    const handleMenuItemClick = (id) => {
        const path = MENU_ITEM_IDS[id];
        dispatch(setSideBarMenuItemId(id));
        navigate(path);
    };

    const sideBarMenuItems = () => (
        <Box sx={{ height: 'auto' }}>
            <List sx={{}}>
                {menuItem?.map((menuItem, index) => (
                    <ListItem
                        disablePadding
                        key={menuItem.value}
                        sx={{
                            background:
                                        selectedMenuItemId === menuItem.id
                                            ? '#FAEDF9'
                                            : 'transparent',
                            display: 'block',
                            borderRadius:
                                        selectedMenuItemId === menuItem.id
                                            ? '6px'
                                            : 'none',

                            width: 'auto',
                            margin: '0 8px'
                        }}
                    >
                        <ListItemButton
                            data-testid = "side_menu_items"
                            sx={{
                                minHeight: 40,
                                justifyContent: drawerOpen
                                    ? 'initial'
                                    : 'center',
                                padding: '8px'
                            }}
                            onClick={() =>
                                handleMenuItemClick(menuItem.id)
                            }
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 40,
                                    mr: drawerOpen ? 1 : 'auto',
                                    justifyContent: 'center'
                                }}
                            >
                                {selectedMenuItemId === menuItem.id
                                    ? menuItem.outlinedIcon
                                    : menuItem.icon}
                            </ListItemIcon>
                            <ListItemText>
                                <Typography
                                    sx={{
                                        color:
                                                    selectedMenuItemId === menuItem.id
                                                        ? '#AD509E'
                                                        : '#344054',
                                        opacity: drawerOpen ? 1 : 0,
                                        fontWeight: 500,
                                        fontSize: '16px',
                                        lineHeight: '24px'
                                    }}
                                >
                                    {menuItem.value}
                                </Typography>
                            </ListItemText>
                        </ListItemButton>
                    </ListItem>
                ))}
                <Divider
                    sx={{
                        width: '100%',
                        color: '#E4E7EC',
                        margin: '24px 0px'
                    }}
                />
                {secondMenu?.map((menuItem, index) => (
                    <ListItem
                        disablePadding
                        key={menuItem.value}
                        sx={{
                            background:
                                        selectedMenuItemId === menuItem.id
                                            ? '#FAEDF9'
                                            : 'transparent',
                            display: 'block',
                            borderRadius:
                                        selectedMenuItemId === menuItem.id
                                            ? '6px'
                                            : 'none',

                            width: 'auto',
                            margin: '0 8px'
                        }}
                    >
                        <ListItemButton
                            sx={{
                                minHeight: 40,
                                justifyContent: drawerOpen
                                    ? 'initial'
                                    : 'center',
                                padding: '8px'
                            }}
                            onClick={() =>
                                handleMenuItemClick(menuItem.id)
                            }
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 40,
                                    mr: drawerOpen ? 1 : 'auto',
                                    justifyContent: 'center'
                                }}
                            >
                                {selectedMenuItemId == menuItem.id
                                    ? menuItem.outlinedIcon
                                    : menuItem.icon}
                            </ListItemIcon>
                            <ListItemText>
                                <Typography
                                    sx={{
                                        color:
                                                    selectedMenuItemId == menuItem.id
                                                        ? '#AD509E'
                                                        : '#344054',
                                        opacity: drawerOpen ? 1 : 0,
                                        fontWeight: 500,
                                        fontSize: '16px',
                                        lineHeight: '24px'
                                    }}
                                >
                                    {menuItem.value}
                                </Typography>
                            </ListItemText>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            {/* <Box sx={{ bottom: 0, position: 'absolute', width: '100%' }}>
                    <Divider sx={{ width: '100%', color: '#E4E7EC' }} />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                            marginRight: '21px',
                            marginTop: '8px',
                            marginBottom: '8px',
                        }}
                        onClick={drawerOpen ? closeDrawer : openDrawer}
                    >
                        {drawerOpen ? <BackButton /> : <ForwardButton />}
                    </Box>
                </Box> */}
        </Box>
    );
    useEffect(()=> {
        if(is_admin && !isOmaniChannel){
            setMenuItem([...MENU_ITEMS, ...ADMIN_MENU_ITEMS]);
            setSecondMenu([...SECOND_MENU,...CREATIVE_MENU]);
        }
        if(is_admin && isOmaniChannel){
            setMenuItem(OminiChannelAdminMenu);
            setSecondMenu(SECOND_MENU);
        }
    },[is_admin,isOmaniChannel]);
    useEffect(() => {
        const matchingTab = CompanyUserBasedTabs.find(tab => tab.company === selectedCompany.id && tab.user === email);
        if (matchingTab) {
            setMenuItem(matchingTab.tabs);
        } if (isOmaniChannel && userCompany?.id === selectedCompany?.id) {
            setMenuItem(ALLOWED_COMPANIES_MENU_ITEMS);
        } else {
            if (is_staff && ![66,61,64,161,165,94].includes(selectedCompany.id)) {
                if (userCompany?.id === selectedCompany?.id) {
                    if(showCreative.includes(selectedCompany.id)){
                        setMenuItem(MENU_ITEMS);
                        setSecondMenu([...SECOND_MENU,...CREATIVE_MENU]);
                    } else{
                        setMenuItem(MENU_ITEMS);
                        setSecondMenu(SECOND_MENU);
                    }
                } else{
                    if(showCreative.includes(selectedCompany.id)){
                        setMenuItem(ALLOWED_COMPANIES_MENU_ITEMS);
                        setSecondMenu([...SECOND_MENU,...CREATIVE_MENU]);
                    } else{
                        setMenuItem(ALLOWED_COMPANIES_MENU_ITEMS);
                        setSecondMenu(SECOND_MENU);
                    }
                }
            }
        }

    }, [is_staff, selectedCompany.id,isOmaniChannel]);
    return (
        <Drawer anchor="left" open={drawerOpen} variant="permanent">
            <DrawerHeader sx={{ justifyContent: 'flex-start', height: '72px' }}>
                {/* <IconButton onClick={closeDrawer} sx={{ marginLeft: '10px' }}>
                <img
                                src={LogoWithoutBrandname}
                                alt="brand logo"
                                width="45px"
                                height="45px"
                            />
                </IconButton> */}
                {drawerOpen ? (
                    <a href={is_admin ? routeNames.ADMIN_DASHBOARD : routeNames.DASHBOARD}>
                        <IconButton
                            sx={{
                                marginLeft: '12px',
                                marginTop: '12px',
                                marginBottom: '12px'
                            }}
                        >
                            <img
                                alt="brand logo"
                                height="48px"
                                src={Logo}
                                width="150px"
                            />
                        </IconButton>
                    </a>
                ) : (
                    <a href={is_admin ? routeNames.ADMIN_DASHBOARD : routeNames.DASHBOARD}>
                        <IconButton sx={{ padding: '0px' }}>
                            <img
                                alt="brand logo"
                                height="45px"
                                src={LogoWithoutBrandname}
                                width="45px"
                            />
                        </IconButton>
                    </a>
                )}
            </DrawerHeader>
            <Divider sx={{ bgcolor: '#E4E7EC', marginBottom: '24px' }} />
            {sideBarMenuItems()}
        </Drawer>
    );
}
